var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-product-price-pill"},[_c('div',{class:`c-product-price-pill__background-color c-product-price-pill__background-color--${_vm.color}`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }